<template>
    <div class="com-codics-ui-sidebar-body"
        :style="{ 'width': value ? '256px !important' : '50px !important', 'border-right': line }">
        <div class="com-codics-ui-sidebar-header" :data-visible="value ? '0' : '1'"
            :style="{ 'height': value ? '72px' : '50px', 'padding': value ? '20px' : '9px', '--lineWidth': value ? '85%' : '65%' }"
            v-show="config.header != null" @click="changeValue();">
            <div class="com-codics-ui-sidebar-header-icon iconfont" v-html="config.header.icon"></div>
            <div class="com-codics-ui-sidebar-header-line" v-show="value">
                <div class="com-codics-ui-sidebar-header-title">{{ config.header.title }}</div>
                <div class="com-codics-ui-sidebar-header-version">{{ config.header.version }}</div>
            </div>
            <div class="com-codics-ui-sidebar-header-menu iconfont" v-show="value">&#xe816;</div>
        </div>
        <div class="com-codics-ui-sidebar-menu-list"
            :style="{ '--menuHeight': (config.header != null && config.footer != null) ? (value ? 'calc(100vh - 144px)' : 'calc(100vh - 100px)') : (config.header == null && config.footer == null ? '100vh' : (value ? 'calc(100vh - 72px)' : 'calc(100vh - 50px)')) }">
            <div class="com-codics-ui-sidebar-menu-item" v-for="(item, index) in data" :key="index"
                v-show="(item.child != null && item.child.length != 0) || (item.url != '' && item.url != null)"
                :style="{ 'padding': value ? '0 10px' : '0', 'height': item.state ? initHeight(item) : '50px' }"
                @click="item.state = !item.state;">
                <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="right" width="160"
                    v-model="item.visible" trigger="hover">
                    <div class="com-codics-ui-sidebar-menu-item-child" v-for="(item2, index2) in item.child"
                        :key="index2" v-html="item2.title" @click="handleListClick(item2)"></div>
                    <div class="com-codics-ui-sidebar-menu-item-icon iconfont" style="width:50px;line-height:50px;"
                        v-html="item.icon" slot="reference" @click.stop="1" v-show="!value && item.child != null"></div>
                </el-popover>
                <div class="com-codics-ui-sidebar-menu-item-icon iconfont" style="width:50px;line-height:50px;"
                    v-html="item.icon" slot="reference" @click.stop="1" v-show="!value && item.child == null"></div>
                <div class="com-codics-ui-sidebar-menu-item-card" v-show="value">
                    <div class="com-codics-ui-sidebar-menu-item-icon iconfont" v-html="item.icon"></div>
                    <div class="com-codics-ui-sidebar-menu-item-title" v-html="item.title"></div>
                    <div class="com-codics-ui-sidebar-menu-item-jt"></div>
                </div>
                <div class="com-codics-ui-sidebar-menu-item-card-child" v-for="(item2, index2) in item.child"
                    :key="index2" v-html="item2.title" @click.stop="handleListClick(item2)"></div>
            </div>
        </div>
        <div class="com-codics-ui-sidebar-footer" v-show="config.footer != null"
            :style="{ 'height': value ? '72px' : '50px', 'padding': value ? '20px' : '9px', '--lineWidth': value ? '85%' : '65%' }">
            <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="right" width="160"
                trigger="hover">
                <div class="com-codics-ui-sidebar-menu-item-child" v-for="(item, index) in ['个人信息', '退出登录']"
                    :key="index" v-html="item" @click="handleMenuClick(item)"></div>
                <el-image class="com-codics-ui-sidebar-footer-himg" slot="reference"
                    :src="userInfo?.user?.himg == null ? '' : ('https://cdn.bosscaigou.com/' + userInfo?.user?.himg)"
                    fit="fill"></el-image>
            </el-popover>
            <div class="com-codics-ui-sidebar-header-line" v-show="value">
                <div class="com-codics-ui-sidebar-header-title">{{ userInfo?.user?.nickname }}</div>
                <div class="com-codics-ui-sidebar-header-version">{{ userInfo?.user?.account }}</div>
            </div>
            <el-popover popper-class="com-codics-ui-sidebar-menu-item-popper" placement="right" width="160"
                trigger="click">
                <div class="com-codics-ui-sidebar-menu-item-child" v-for="(item, index) in ['个人信息', '退出登录']"
                    :key="index" v-html="item" @click="handleMenuClick(item)"></div>
                <div class="com-codics-ui-sidebar-header-menu iconfont" slot="reference" v-show="value">&#xe866;</div>
            </el-popover>
        </div>
    </div>
</template>

<script>
/*添加cookie*/
export const setCookie = (name, value) => {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
};

/*读取cookie*/
export const getCookie = (name) => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
};

/*删除cookie*/
export const delCookie = (name) => {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";path=/;expires=" + exp.toGMTString();
};


export const setCookieWithExp = (name, value, daysUntilExpire) => {
    var date = new Date();
    date.setTime(date.getTime() + (daysUntilExpire * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
import { mapState } from 'vuex';
export default {
    props: {
        value: {
            type: Boolean,
            default: true
        },
        config: {
            type: Object,
            default: () => {
                return {
                    header: {
                        icon: "&#xe8c6;",
                        title: "在线询价系统",
                        version: "v 1.0.0"
                    },
                    footer: {

                    }
                }
            }
        },
        data: {
            type: Array,
            default: () => {
                return [
                    {
                        icon: "&#xe88c;",
                        title: "用户管理",
                        state: false,
                        child: [
                            {
                                title: "员工管理",
                                url: "#"
                            },
                            {
                                title: "角色管理",
                                url: "#"
                            },
                            {
                                title: "菜单管理",
                                url: "#"
                            },
                            {
                                title: "客户管理",
                                url: "#"
                            }
                        ]
                    },
                    {
                        icon: "&#xe6d4;",
                        title: "采购管理",
                        state: false,
                    },
                    {
                        icon: "&#xe6ed;",
                        title: "系统管理",
                        state: false,
                    }
                ]
            }
        },
        line: {
            type: String,
            default: '1px solid var(--sbar-l-color)'
        }
    },
    data() {
        return {

        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('input', getCookie('com-codics-ui-sidebar-body') != null);
        })
    },
    watch: {
        value(newValue, oldValue) {
            if (newValue) {
                setCookie('com-codics-ui-sidebar-body', newValue);
            } else {
                delCookie('com-codics-ui-sidebar-body');
            }
        }
    },
    methods: {
        handleListClick(item) {
            this.$router.push({ name: item.title, params: {}, query: {} }, () => { }, () => { });
        },
        initHeight(item) {
            return item.child == null ? '50px' : (item.child.length + 1) * 50 + 'px';
        },
        handleMenuClick(item) {
            switch (item) {
                case '个人信息':
                    this.$router.push({ name: '个人信息', params: {}, query: {} }, () => { }, () => { });
                    break;
                case '退出登录':
                    this.$store.dispatch('logout');
                    window.location.reload();
                    break;
            }
        },
        changeValue() {
            this.$emit('input', !this.value);
            this.data.forEach(item => {
                item.state = false;
            });
        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
}
</script>

<style>
.com-codics-ui-sidebar-body {
    height: 100%;
    width: 256px;
    max-width: 256px;
    min-height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    background: #FFF;
    background: var(--sbar-bg-color);
    transition: .3s;
    z-index: 20;
}

.com-codics-ui-sidebar-header {
    height: 72px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding: 20px;
    cursor: pointer;
    transition: .3s;
}

.com-codics-ui-sidebar-header:hover .com-codics-ui-sidebar-header-menu {
    transform: rotate(90deg);
}

.com-codics-ui-sidebar-header::before {
    content: '';
    height: 1px;
    width: var(--lineWidth);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #DDD;
    background: var(--sbar-l-2-color);
    transition: .03s;
}

.com-codics-ui-sidebar-header-icon {
    height: 100%;
    width: 32px;
    position: relative;
    float: left;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    font-size: 17px;
    text-align: center;
    line-height: 32px;
    color: #FFF;
    background: #000;
    border-radius: 5px;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-ui-sidebar-header-line {
    height: 100%;
    width: calc(100% - 64px);
    float: left;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding-left: 15px;
}

.com-codics-ui-sidebar-header-title {
    height: 16px;
    width: 100%;
    float: left;
    position: relative;
    box-sizing: border-box;
    line-height: 16px;
    font-size: 12px;
    color: #000;
    color: var(--sbar-title-color);
    font-weight: 600;
    user-select: none;
    -webkit-user-drag: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.com-codics-ui-sidebar-header-version {
    height: 16px;
    width: 100%;
    float: left;
    position: relative;
    box-sizing: border-box;
    line-height: 16px;
    font-size: 11px;
    color: #666;
    color: var(--sbar-title-hint-color);
    font-weight: 600;
    user-select: none;
    -webkit-user-drag: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.com-codics-ui-sidebar-header-menu {
    height: 100%;
    width: 32px;
    float: right;
    position: relative;
    box-sizing: border-box;
    font-size: 19px;
    text-align: center;
    line-height: 32px;
    color: #000;
    color: var(--sbar-font-color);
    user-select: none;
    -webkit-user-drag: none;
    transition: .3s;
}

.com-codics-ui-sidebar-menu-list {
    height: var(--menuHeight);
    min-height: calc(100% - 154px);
    width: 100%;
    float: left;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    overflow-y: auto;
    padding: 10px 0;
    transition: .3s;
}

.com-codics-ui-sidebar-menu-item {
    height: 50px;
    width: 100%;
    float: left;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    cursor: pointer;
    transition: .3s;
    line-height: 50px;
    font-size: 14px;
    color: #000;
    color: var(--sbar-font-color);
    text-align: center;
    user-select: none;
    -webkit-user-drag: none;
    transition: .3s;
    overflow: hidden;
}

.com-codics-ui-sidebar-menu-item-card {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    border-radius: 20px;
    transition: .3s;
    margin: 5px 0;
    padding-right: 5px;
}

.com-codics-ui-sidebar-menu-item:hover .com-codics-ui-sidebar-menu-item-card {
    background: #F7F7F7;
    background: var(--sbar-menu-item-hover-color);
}

.com-codics-ui-sidebar-menu-item-icon {
    height: 100%;
    width: 40px;
    float: left;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    color: #000;
    color: var(--sbar-font-color);
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-ui-sidebar-menu-item-title {
    height: 100%;
    width: calc(100% - 80px);
    float: left;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    font-size: 12px;
    text-align: left;
    line-height: 40px;
    color: #000;
    color: var(--sbar-font-color);
    user-select: none;
    font-weight: bolder;
    -webkit-user-drag: none;
}

.com-codics-ui-sidebar-menu-item-jt {
    height: 100%;
    width: 40px;
    float: right;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.com-codics-ui-sidebar-menu-item-jt::before {
    height: 0px;
    width: 0px;
    content: '';
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: rotate(-45deg);
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    border-left: 1px solid var(--sbar-font-color);
    border-bottom: 1px solid var(--sbar-font-color);
    transition: .1s;
}

.com-codics-ui-sidebar-menu-item:hover .com-codics-ui-sidebar-menu-item-jt::before {
    height: 5px;
    width: 5px;
    top: -2.2px;
}

.com-codics-ui-sidebar-menu-item-child {
    height: 40x;
    width: 100%;
    float: left;
    position: relative;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    font-size: 12px;
    text-align: left;
    line-height: 40px;
    color: #000;
    user-select: none;
    font-weight: bolder;
    -webkit-user-drag: none;
    cursor: pointer;
    transition: .3s;
    padding-left: 25px;
}

.com-codics-ui-sidebar-menu-item-child:hover {
    background: rgba(0, 0, 0, .1);
    background: var(--sbar-menu-item-hover-color);
}

.com-codics-ui-sidebar-menu-item-popper {
    padding: 5px !important;
}

.com-codics-ui-sidebar-menu-item::before {
    height: calc(100% - 60px);
    width: 1px;
    content: '';
    position: absolute;
    margin: auto;
    left: 30px;
    bottom: 5px;
    background: #E0E0E0;
    background: var(--sbar-menu-item-child-l-color);
    transition: .3s;
}

.com-codics-ui-sidebar-menu-item-card-child {
    height: 40px;
    width: calc(100% - 30px);
    position: relative;
    float: left;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    border-radius: 20px;
    transition: .3s;
    margin: 5px 0;
    padding-right: 5px;
    padding-left: 20px;
    font-size: 12px;
    text-align: left;
    line-height: 40px;
    color: #666;
    color: var(--sbar-menu-item-font-color);
    user-select: none;
    font-weight: bolder;
    -webkit-user-drag: none;
    cursor: pointer;
    margin-left: 30px;
}

.com-codics-ui-sidebar-menu-item-card-child:hover {
    background: rgba(0, 0, 0, .08);
    background: var(--sbar-menu-item-child-hover-color);
}

.com-codics-ui-sidebar-menu-item-card-child::before {
    content: '';
    height: 5px;
    width: 5px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 20px;
    bottom: 0;
    box-sizing: border-box;
    transform: rotate(-45deg);
    border-right: 1px solid #666;
    border-bottom: 1px solid #666;
    border-right: 1px solid var(--sbar-menu-item-font-color);
    border-bottom: 1px solid var(--sbar-menu-item-font-color);
    transition: .1s;
    opacity: 0;
}

.com-codics-ui-sidebar-menu-item-card-child::after {
    content: '';
    height: 1px;
    width: 10px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 20px;
    bottom: 0;
    box-sizing: border-box;
    background: #666;
    background: var(--sbar-menu-item-font-color);
    transition: .1s;
    opacity: 0;
}

.com-codics-ui-sidebar-menu-item-card-child:hover::before {
    opacity: 1 !important;
}

.com-codics-ui-sidebar-menu-item-card-child:hover::after {
    opacity: 1 !important;
}

.com-codics-ui-sidebar-footer {
    height: 72px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding: 20px;
    cursor: pointer;
    transition: .3s;
}

.com-codics-ui-sidebar-footer-himg {
    height: 100%;
    width: 32px;
    position: relative;
    float: left;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    border-radius: 5px;
    user-select: none;
    -webkit-user-drag: none;
    border: #F0F0F0 solid 1px;
    border: var(--sbar-himg-l-color) solid 1px;
}

.com-codics-ui-sidebar-footer::before {
    content: '';
    height: 1px;
    width: var(--lineWidth);
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    background: #DDD;
    background: var(--sbar-l-2-color);
    transition: .03s;
}
</style>